import { render, staticRenderFns } from "./OxideSwitch.vue?vue&type=template&id=7a4b2a0c&scoped=true&lang=html&"
import script from "./OxideSwitch.vue?vue&type=script&lang=js&"
export * from "./OxideSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4b2a0c",
  null
  
)

export default component.exports